
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskActionModel } from './Entities.GormCrm.TaskAction';
import { Model, ModelProperty } from 'models/Model';


export class TaskAreaModel extends Model<TaskAreaModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'taskArea.property.id', isHidden: true },
		{ name: 'name', type: 'string', languageString: 'taskArea.property.name' },
		{ name: 'color', type: 'string', languageString: 'taskArea.property.color' },
		{ name: 'deleted', type: 'Date', languageString: 'taskArea.property.deleted', isHidden: true },
		{ name: 'taskActions', type: 'TaskActionModel[]', languageString: 'taskArea.property.taskActions', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskActionModel }, properties: () => { return TaskActionModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public color: string;
	public deleted?: Date;
	public taskActions: TaskActionModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.color = '';
		this.deleted = undefined;
		this.taskActions = [];
		
	}
	getProperties(){
		return TaskAreaModel.classProperties;
	}
}

